(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("srtm-tiles", [], factory);
	else if(typeof exports === 'object')
		exports["srtm-tiles"] = factory();
	else
		root["srtm-tiles"] = factory();
})(self, function() {
return 